export const environment = {
  production: true,
  baseCurrency: "AED",
  endPoints: {
    offlineSeats: "http://154.41.209.93:7025",
    brandedFairs: "https://flightprov.travelnow.global",
    searchflow: "https://flightsearch.travelnow.global",
    BookingFlow: "https://flightflow.travelnow.global",
    FareRules: "https://flightprov.travelnow.global",
    asm: "https://backofficeapi.travelnow.global",
    Apihotels: "https://hotels.travelnow.global",
    users: "https://flightsearch.travelnow.global",
    admin: "https://adminapi.travelnow.global/",
    getDPayment: "https://adminapi.travelnow.global/",
    bookHotels: "https://hotels.travelnow.global",
    hotelPrepay: "https://prepayapi.travelnow.global",
    backOffice: "https://backofficeapi.travelnow.global",
    FlightTop: "https://flightsearch.travelnow.global",
    offers: {
      getAll: "http://154.41.209.93:7893/api/GetAllOffersAPI?POS=",
      getByID: "http://154.41.209.93:7893/api/GetOfferByIdAPI?OfferId=",
      BookOffer: "http://154.41.209.93:7895/api/BookOffer",
      RetriveItineraryDetails: "/api/Admin/RetriveItineraryDetails",
    },
    // offlineSeats: "http://41.215.243.36:7025",
    // searchflow: "https://wegosearch.travelnow.global",
    // BookingFlow: "https://wegobook.travelnow.global",
    // FareRules: "https://wegoprovider.travelnow.global",
    // asm: "https://backofficeapi.travelnow.global",
    // Apihotels: "https://hotels.rayacom",
    // users: "https://usersapi.travelnow.global",
    // admin: "https://adminapi.travelnow.global/",
    // getDPayment: "http://41.215.243.36:1112/",
    // bookHotels: "https://hotels.travelnow.global",
    // prepay: "https://prepayapi.travelnow.global",
    // hotelPrepay: "https://prepayapi.travelnow.global",
    // brandedFairs: "https://flightprov.travelnow.global",
    // backOffice: "https://backofficeapi.travelnow.global",
    // FlightTop: "https://wegosearch.travelnow.global",
    // offers: {
    //   getAll: "http://41.215.243.36:7893/api/GetAllOffersAPI?POS=",
    //   getByID: "http://41.215.243.36:7893/api/GetOfferByIdAPI?OfferId=",
    //   BookOffer: "http://41.215.243.36:7895/api/BookOffer",
    //   RetriveItineraryDetails: "/api/Admin/RetriveItineraryDetails",
    // },
  },
};
